var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState, useMemo, useCallback } from 'react';
import DOMPurify from 'dompurify';
import { useFormik } from 'formik';
import useConfigStore from '../../../stores/configStore';
import { UNIFIED_ACTION } from '../../../utils/types';
import PolicyFormInput from '../PolicyFormInput';
import PolicyStepsHeader from '../PolicyStepsHeader';
import PolicyFormProgressBar from '../PolicyFormProgressBar';
import { findQuestionsWithConditions, pruneStaleValues } from './filter';
import { createValidationSchema, normalizeForComparison } from './validations';
import useWidgetStore from '../../../stores/widgetStore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import _ from 'lodash';
import InputTooltip from '../../Inputs/InputTooltip';
import { flattenNestedGroupAnswers, forEachQuestionDeep, formatDate, getGroupQuestion, getMatchedKey, isAddressObject, mergeHelperAndHint, removeUnderScore, searchValueRecursively, } from '../../../utils/common';
import useLatestQuote from '../../../hooks/useLatestQuote';
import useProductStore from '../../../stores/productStore';
import MultiSelectTable from '../MultiSelectTable';
function camelToWords(camelcase) {
    if (/[a-z][A-Z]/.test(camelcase)) {
        return camelcase.replace(/([A-Z])/g, ' $1').trim();
    }
    else {
        return camelcase;
    }
}
var FormSection = function (_a) {
    var groupKey = _a.groupKey, groups = _a.groups, _b = _a.title, title = _b === void 0 ? '' : _b, _c = _a.subTitle, subTitle = _c === void 0 ? '' : _c, _d = _a.sectionBanner, sectionBanner = _d === void 0 ? '' : _d, _e = _a.formTopText, formTopText = _e === void 0 ? '' : _e, questions = _a.questions, totalSteps = _a.totalSteps, step = _a.step, skippedGroups = _a.skippedGroups, answers = _a.answers, onSubmit = _a.onSubmit, onBack = _a.onBack, apiValidationErrors = _a.apiValidationErrors;
    var _f = useWidgetStore(), toggleModal = _f.toggleModal, setIsEditRequested = _f.setIsEditRequested, setSelectedQuote = _f.setSelectedQuote, setCurrQuestionGroup = _f.setCurrQuestionGroup, setUnifiedState = _f.setUnifiedState, unifiedState = _f.unifiedState;
    var formTheme = useConfigStore().style.formTheme;
    var Underwriter = useProductStore().Underwriter;
    var isModern = formTheme === 'modern';
    var _g = useState(), validationSchema = _g[0], setValidationSchema = _g[1];
    var _h = useState(false), isFocusedErrorField = _h[0], setIsFocusedErrorField = _h[1];
    var formik = useFormik({
        initialValues: answers[groupKey] || {},
        onSubmit: function (values, _a) {
            var setStatus = _a.setStatus;
            return onSubmit(values, setStatus);
        },
        validationSchema: validationSchema
    });
    var removedQuestions = useMemo(function () {
        var _a;
        return findQuestionsWithConditions(questions, (_a = {}, _a[groupKey] = formik.values, _a), answers);
    }, [questions, formik.values, groupKey, answers]);
    var getFilteredQuestions = useCallback(function () {
        return questions.filter(function (q) { return !removedQuestions.includes(q.questionKey); });
    }, [questions, removedQuestions]);
    useEffect(function () {
        setValidationSchema(createValidationSchema({
            questions: questions,
            removedQuestions: removedQuestions,
            values: answers,
            tempValues: formik.values,
            apiValidationErrors: apiValidationErrors,
            groupKey: groupKey
        }));
    }, [
        questions,
        answers,
        formik.values,
        removedQuestions,
        apiValidationErrors,
        groupKey,
    ]);
    useEffect(function () {
        var el = document.getElementById('containerId');
        if (el) {
            el.scrollTop = 0;
        }
    }, []);
    useEffect(function () {
        if ((apiValidationErrors || formik.submitCount > 0) &&
            Object.keys(formik.errors).length > 0) {
            var findFirstErrorField_1 = function (errors, prefix) {
                if (prefix === void 0) { prefix = ''; }
                for (var key in errors) {
                    var fieldPath = prefix ? "".concat(prefix, ".").concat(key) : key;
                    if (typeof errors[key] === 'string') {
                        return fieldPath;
                    }
                    else if (typeof errors[key] === 'object') {
                        var nestedError = findFirstErrorField_1(errors[key], fieldPath);
                        if (nestedError)
                            return nestedError;
                    }
                }
                return null;
            };
            var firstErrorField = findFirstErrorField_1(formik.errors);
            if (firstErrorField) {
                var selectors = [
                    "[name=\"".concat(firstErrorField, "\"]"),
                    "[id=\"".concat(firstErrorField, "\"]"),
                    "[data-field=\"".concat(firstErrorField, "\"]"),
                    "[data-field-container=\"".concat(firstErrorField.split('.')[0], "\"]"),
                ];
                var errorElement = null;
                for (var _i = 0, selectors_1 = selectors; _i < selectors_1.length; _i++) {
                    var selector = selectors_1[_i];
                    var element = document.querySelector(selector);
                    // Check if element exists and is visible
                    if (element && element.offsetParent !== null) {
                        errorElement = element;
                        break;
                    }
                }
                if (errorElement) {
                    errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }
        }
    }, [
        formik.submitCount,
        apiValidationErrors,
        Object.keys(formik.errors).length > 0,
    ]);
    useEffect(function () {
        if (apiValidationErrors && validationSchema) {
            var errorKeys = Object.keys(apiValidationErrors);
            errorKeys.forEach(function (key) {
                formik.setFieldTouched(key, true, true);
            });
        }
    }, [apiValidationErrors, validationSchema]);
    useEffect(function () {
        var filteredQuestions = getFilteredQuestions();
        forEachQuestionDeep(filteredQuestions, function (q, parentQuestionKey) {
            var qKey = parentQuestionKey
                ? "".concat(parentQuestionKey, ".").concat(q.questionKey)
                : q.questionKey;
            var existFormValue = _.get(formik.values, qKey);
            if ((existFormValue === undefined || existFormValue === null) &&
                qKey &&
                q.value &&
                q.inputType !== 'void') {
                try {
                    formik.setFieldValue(qKey, q.value);
                }
                catch (error) {
                    console.log(error);
                }
            }
        }, formik.values);
    }, [questions, removedQuestions]);
    useEffect(function () {
        var filteredQuestions = getFilteredQuestions();
        // @ts-ignore
        var timeOut;
        if (apiValidationErrors && !isFocusedErrorField) {
            var _apiValidationErrors_1 = JSON.parse(JSON.stringify(apiValidationErrors));
            var errorKeys_2 = Object.keys(_apiValidationErrors_1);
            for (var _i = 0, errorKeys_1 = errorKeys_2; _i < errorKeys_1.length; _i++) {
                var key = errorKeys_1[_i];
                var eValue = _apiValidationErrors_1[key];
                if (eValue &&
                    'value' in eValue &&
                    eValue.value &&
                    eValue.message &&
                    isAddressObject(eValue.value)) {
                    var addressKeyFromError = eValue.message.match(/address\.(city|county|region|street|country|secondary|postalCode)/i);
                    if (addressKeyFromError && addressKeyFromError[1]) {
                        delete _apiValidationErrors_1[key];
                        _apiValidationErrors_1["".concat(key, ".").concat(addressKeyFromError[1])] = __assign({}, eValue);
                    }
                }
            }
            errorKeys_2 = Object.keys(_apiValidationErrors_1);
            forEachQuestionDeep(filteredQuestions, function (q, parentQuestionKey) {
                var _a;
                var qKey = parentQuestionKey
                    ? "".concat(parentQuestionKey, ".").concat(q.questionKey)
                    : q.questionKey;
                var eKey = getMatchedKey(errorKeys_2, q.questionKey) ||
                    getMatchedKey(errorKeys_2, qKey);
                if (eKey &&
                    qKey &&
                    !['sectionHeading', 'sectionHeadingEnd', 'group'].includes(q.inputType)) {
                    var normalizedCurrentValue = normalizeForComparison(_.get(formik.values, qKey), q.inputType);
                    var errorDetails = _apiValidationErrors_1[eKey];
                    var invalidApiValue = 'value' in errorDetails ? errorDetails.value : undefined;
                    if (isAddressObject(invalidApiValue)) {
                        var k = "".concat(eKey).split('.')[1];
                        var v = invalidApiValue[k];
                        if (v) {
                            invalidApiValue = v;
                        }
                    }
                    var normalizedInvalidValue = normalizeForComparison(invalidApiValue, q.inputType);
                    if (('required' in errorDetails &&
                        errorDetails.required &&
                        !normalizedCurrentValue) ||
                        ('value' in errorDetails &&
                            getMatchedKey([normalizedCurrentValue], normalizedInvalidValue))) {
                        (_a = document.getElementById(qKey)) === null || _a === void 0 ? void 0 : _a.focus();
                        timeOut = setTimeout(function () {
                            var _a;
                            (_a = document.getElementById(qKey)) === null || _a === void 0 ? void 0 : _a.blur();
                            setIsFocusedErrorField(true);
                        }, 200);
                        return { isBreak: true };
                    }
                }
            });
        }
        return function () {
            if (timeOut) {
                clearTimeout(timeOut);
            }
        };
    }, [questions, removedQuestions, apiValidationErrors, isFocusedErrorField]);
    var _j = useMemo(function () {
        if ((unifiedState === null || unifiedState === void 0 ? void 0 : unifiedState.action) === UNIFIED_ACTION.SHOW_ACK_QUESTIONS_TO_FE) {
            var filteredQuestions = getFilteredQuestions();
            var paths_1 = [];
            forEachQuestionDeep(filteredQuestions, function (q, parentKey) {
                var qKey = parentKey
                    ? "".concat(parentKey, ".").concat(q.questionKey)
                    : q.questionKey;
                // Target checkboxes that are not disabled and not void
                if (q.inputType === 'checkbox' &&
                    !q.isDisabled &&
                    q.inputType !== 'void') {
                    paths_1.push(qKey);
                }
            });
            var isAllChecked = paths_1.length > 0 &&
                paths_1.every(function (path) { return _.get(formik.values, path) === true; });
            return { allChecked: isAllChecked, visibleCheckboxPaths: paths_1 };
        }
        return { allChecked: false, visibleCheckboxPaths: null };
    }, [getFilteredQuestions, formik.values, unifiedState === null || unifiedState === void 0 ? void 0 : unifiedState.action]), allChecked = _j.allChecked, visibleCheckboxPaths = _j.visibleCheckboxPaths;
    var handleMasterToggle = function (checked) {
        if (visibleCheckboxPaths) {
            var newValues_1 = __assign({}, formik.values);
            visibleCheckboxPaths.forEach(function (path) {
                _.set(newValues_1, path, checked);
            });
            formik.setValues(newValues_1);
        }
    };
    var getClassOfBusinessValues = function (ques) {
        var values = (formik || {}).values;
        var _a = ques || {}, questionKey = _a.questionKey, options = _a.options;
        if (!values || !questionKey)
            return undefined;
        if (values[questionKey]) {
            return values[questionKey];
        }
        var match = questionKey.match(/^Location([0-9]+)ClassOfBusiness_[0-9]+$/);
        var locationIndex = match ? match[1] : null;
        if (!locationIndex)
            return undefined;
        var prefix = "Location".concat(locationIndex, "ClassOfBusiness_");
        var candidateKeys = Object.keys(values).filter(function (key) { return key.startsWith(prefix) && key !== questionKey; });
        var _loop_1 = function (key) {
            var value = values[key];
            var isValidOption = options === null || options === void 0 ? void 0 : options.some(function (opt) { return opt.value === value; });
            if (isValidOption) {
                formik.setFieldValue(questionKey, value, true);
                return { value: value };
            }
        };
        for (var _i = 0, candidateKeys_1 = candidateKeys; _i < candidateKeys_1.length; _i++) {
            var key = candidateKeys_1[_i];
            var state_1 = _loop_1(key);
            if (typeof state_1 === "object")
                return state_1.value;
        }
        return undefined;
    };
    var renderQuestions = function (endKey, index) {
        var _a, _b, _c;
        if (index === void 0) { index = 0; }
        var filteredQuestions = getFilteredQuestions();
        var struct = {};
        var isSomethingRender = false;
        var i = index;
        var _loop_2 = function () {
            var ques = filteredQuestions[i];
            if (endKey && ques.questionKey === endKey) {
                return "break";
            }
            if (['sectionHeadingEnd'].includes(ques.inputType)) {
                return "continue";
            }
            var repeatKeys = [''];
            if (ques.inputType === 'null') {
                if (ques.questionKey && ques.value) {
                    isSomethingRender = true;
                    struct[ques.questionKey] = {
                        key: 'plain',
                        value: (React.createElement("input", { type: "hidden", key: ques.questionKey, id: ques.questionKey }))
                    };
                }
                return "continue";
            }
            else if (ques.inputType === 'sectionHeading') {
                var _d = renderQuestions("".concat(ques.questionKey, "___end"), i + 1), subStruct = _d.struct, isRender = _d.isSomethingRender, newIndex = _d.i;
                i = newIndex;
                if (subStruct && isRender) {
                    isSomethingRender = true;
                    struct[ques.questionKey] = {
                        key: 'section',
                        value: subStruct,
                        question: ques.question
                    };
                }
                return "continue";
            }
            else if (ques.inputType === 'group' && ques.repeatBy) {
                var value = formik.values[ques.repeatBy.targetKey];
                var config = questions.find(function (q) { var _a; return q.questionKey === ((_a = ques.repeatBy) === null || _a === void 0 ? void 0 : _a.targetKey); });
                if ((config === null || config === void 0 ? void 0 : config.inputType) === 'number') {
                    if (typeof value === 'number' && value > -1) {
                        repeatKeys = Array.from({ length: value }).map(function (_, i) {
                            return (i + 1).toString();
                        });
                    }
                    else {
                        repeatKeys = [];
                    }
                }
                else if ((config === null || config === void 0 ? void 0 : config.inputType) === 'multiselect') {
                    if (Array.isArray(value)) {
                        repeatKeys = value;
                    }
                    else {
                        repeatKeys = [];
                    }
                }
            }
            var currentRender = ques.inputType === 'group' ? (ques.inputType === 'group' &&
                ques.renderAs === 'multi_table' &&
                ques.targetQuestionKey ? (React.createElement(MultiSelectTable, { formik: formik, formikValues: formik.values, question: ques, apiValidationErrors: apiValidationErrors, targetQuestionKey: ques.targetQuestionKey, answers: answers, groupKey: groupKey })) : (repeatKeys.map(function (repeatKey) {
                var questionKey = ques.questionKey;
                if (repeatKey) {
                    questionKey = "".concat(ques.questionKey, "_").concat(repeatKey);
                }
                var groupQuestions = getGroupQuestion(removedQuestions, questionKey, ques.questions);
                return (groupQuestions === null || groupQuestions === void 0 ? void 0 : groupQuestions.length) ? (React.createElement("div", { className: "col-span-2 pb-4", "data-field-container": questionKey, key: questionKey },
                    React.createElement("h3", { className: "text-left text-[22px] font-bold mb-2 text-[#252846] flex justify-between items-center" },
                        removeUnderScore(ques.question),
                        " ",
                        repeatKey,
                        ((ques === null || ques === void 0 ? void 0 : ques.helper) || (ques === null || ques === void 0 ? void 0 : ques.hint)) && (React.createElement(InputTooltip, { text: mergeHelperAndHint(ques === null || ques === void 0 ? void 0 : ques.helper, ques === null || ques === void 0 ? void 0 : ques.hint) }))),
                    React.createElement("div", { className: "border border-[#E9EDF7] rounded-xl p-5 ".concat(ques.direction === 'grid'
                            ? 'grid grid-cols-1 gap-x-8 gap-y-6'
                            : "flex gap-4 ".concat(ques.direction === 'vertical'
                                ? 'flex-col'
                                : ques.direction === 'vertical_full'
                                    ? 'flex-col'
                                    : ques.direction === 'horizontal_table'
                                        ? "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 items-end gap-y-4 md:gap-y-8"
                                        : "grid grid-cols-1 ".concat(groupQuestions.length === 1
                                            ? 'grid-cols-1'
                                            : 'sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4', " gap-4 items-start"))) }, groupQuestions.map(function (innerQues) {
                        var _a, _b, _c, _d, _e, _f, _g;
                        return (React.createElement(PolicyFormInput, { key: "".concat(questionKey, ".").concat(innerQues.questionKey), questionKey: "".concat(questionKey, ".").concat(innerQues.questionKey), question: innerQues, dataField: "".concat(questionKey, ".").concat(innerQues.questionKey), label: removeUnderScore("".concat(innerQues.question)), value: (_b = (_a = formik === null || formik === void 0 ? void 0 : formik.values) === null || _a === void 0 ? void 0 : _a[questionKey]) === null || _b === void 0 ? void 0 : _b[innerQues === null || innerQues === void 0 ? void 0 : innerQues.questionKey], voidValue: innerQues.value, inputType: innerQues.inputType, min: innerQues.min, max: innerQues.max, validation: innerQues.validation, isDisabled: innerQues.isDisabled, helper: innerQues.helper, hint: innerQues === null || innerQues === void 0 ? void 0 : innerQues.hint, handleChange: formik === null || formik === void 0 ? void 0 : formik.handleChange("".concat(questionKey, ".").concat(innerQues.questionKey)), handleChangeDate: function (date) {
                                var dateObj = '';
                                if (date) {
                                    dateObj = formatDate(new Date(date));
                                }
                                formik.setFieldValue("".concat(questionKey, ".").concat(innerQues.questionKey), dateObj);
                            }, handleChangeAutocomplete: function (val) {
                                formik.setFieldValue("".concat(questionKey, ".").concat(innerQues.questionKey), val, true);
                            }, handleBlur: formik.handleBlur, options: innerQues === null || innerQues === void 0 ? void 0 : innerQues.options, placeholder: innerQues.placeholder, defaultChecked: ((_d = (_c = formik === null || formik === void 0 ? void 0 : formik.values) === null || _c === void 0 ? void 0 : _c[questionKey]) === null || _d === void 0 ? void 0 : _d[innerQues === null || innerQues === void 0 ? void 0 : innerQues.questionKey]) || ((_e = answers === null || answers === void 0 ? void 0 : answers[groupKey]) === null || _e === void 0 ? void 0 : _e[innerQues === null || innerQues === void 0 ? void 0 : innerQues.questionKey]), errors: apiValidationErrors || formik.submitCount > 0
                                ? (_g = (_f = formik.errors) === null || _f === void 0 ? void 0 : _f[questionKey]) === null || _g === void 0 ? void 0 : _g[innerQues.questionKey]
                                : undefined, touched: apiValidationErrors || formik.submitCount > 0, docLink: innerQues.docLink, linkText: innerQues.linkText, allowMultiple: innerQues.allowMultiple, enforceNone: innerQues.enforceNone, subHeading: innerQues === null || innerQues === void 0 ? void 0 : innerQues.subHeading, variant: innerQues === null || innerQues === void 0 ? void 0 : innerQues.variant }));
                    })))) : null;
            }))) : (React.createElement("div", { key: ques.questionKey, className: "w-full col-span-2" },
                React.createElement(PolicyFormInput, { key: ques.questionKey, questionKey: ques.questionKey, question: ques, dataField: ques.questionKey, label: removeUnderScore("".concat((_a = ques.question) !== null && _a !== void 0 ? _a : '')), value: (function () {
                        var _a, _b;
                        if ((_a = ques === null || ques === void 0 ? void 0 : ques.questionKey) === null || _a === void 0 ? void 0 : _a.match(/^Location([0-9]+)ClassOfBusiness_[0-9]+$/)) {
                            return getClassOfBusinessValues(ques);
                        }
                        return (_b = formik === null || formik === void 0 ? void 0 : formik.values) === null || _b === void 0 ? void 0 : _b[ques === null || ques === void 0 ? void 0 : ques.questionKey];
                    })(), voidValue: ques.value, inputType: ques.inputType, min: ques.min, max: ques.max, validation: ques.validation, coverages: ques.coverages, protection_amounts: ques.protection_amounts, isDisabled: ques.isDisabled, helper: ques.helper, hint: ques === null || ques === void 0 ? void 0 : ques.hint, handleChange: formik === null || formik === void 0 ? void 0 : formik.handleChange(ques.questionKey), handleChangeDate: function (date) {
                        var dateObj = '';
                        if (date) {
                            dateObj = formatDate(new Date(date));
                        }
                        formik.setFieldValue(ques.questionKey, dateObj);
                    }, handleChangeAutocomplete: function (val) {
                        formik.setFieldValue(ques.questionKey, val, true);
                    }, handleBlur: formik.handleBlur, options: ques === null || ques === void 0 ? void 0 : ques.options, placeholder: ques.placeholder, defaultChecked: (_b = answers === null || answers === void 0 ? void 0 : answers[groupKey]) === null || _b === void 0 ? void 0 : _b[ques === null || ques === void 0 ? void 0 : ques.questionKey], errors: apiValidationErrors || formik.submitCount > 0
                        ? (_c = formik.errors) === null || _c === void 0 ? void 0 : _c[ques === null || ques === void 0 ? void 0 : ques.questionKey]
                        : undefined, touched: apiValidationErrors || formik.submitCount > 0, docLink: ques.docLink, linkText: ques.linkText, allowMultiple: ques.allowMultiple, enforceNone: ques.enforceNone, variant: ques.variant, submitCount: formik.submitCount, formikSetFieldValue: formik.setFieldValue, formikErrors: formik.errors, formikHandleChange: formik.handleChange })));
            if (Array.isArray(currentRender)
                ? currentRender.some(function (v) { return !!v; })
                : currentRender) {
                isSomethingRender = true;
                struct[ques.questionKey] = {
                    key: 'plain',
                    value: currentRender
                };
            }
        };
        for (; i < filteredQuestions.length; i++) {
            var state_2 = _loop_2();
            if (state_2 === "break")
                break;
        }
        return { struct: struct, isSomethingRender: isSomethingRender, i: i };
    };
    var renderData = renderQuestions();
    var renderRecursively = function (data) {
        var render = [];
        Object.keys(data).forEach(function (key) {
            var type = data[key].key;
            var value = data[key].value;
            if (type === 'plain') {
                render.push(value);
            }
            else if (type === 'section') {
                var question = data[key].question;
                render.push(React.createElement("div", { className: "col-span-2 py-4", "data-field-container": key, key: key },
                    question ? (React.createElement("h3", { className: "text-left text-[18px] md:text-[22px] font-bold mb-2 text-[#252846]" }, question)) : null,
                    React.createElement("div", { className: "border border-[#E9EDF7] rounded-xl grid grid-cols-1 gap-4 p-4 md:p-5" }, renderRecursively(value))));
            }
        });
        return render;
    };
    var getGroupDetailsTitle = function (key) {
        var words = camelToWords(key || '').trim();
        var excludedKeys = new Set([
            'to_get_started_review_and_agree_to_our_terms_and_conditions',
        ]);
        if (excludedKeys.has(key)) {
            return words;
        }
        return /details$/i.test(words) ? words : "".concat(words, " details");
    };
    return (React.createElement("form", { className: 'w-full h-full flex flex-col items-center justify-start', onSubmit: function (e) {
            e.preventDefault();
            formik.handleSubmit();
        } },
        React.createElement("div", { className: "w-full ".concat(isModern
                ? 'sticky top-0 z-40 bg-white'
                : 'sticky top-0 z-40 shadow-sm') },
            React.createElement(PolicyStepsHeader, { theme: formTheme, hideSteps: (Underwriter === null || Underwriter === void 0 ? void 0 : Underwriter.widgetFlow) === 'hartford_paf', steps: isModern
                    ? __spreadArray(__spreadArray([], groups.map(function (q, i) {
                        return {
                            stepText: (React.createElement("span", { className: "capitalize" }, camelToWords(q))),
                            isStepActive: i === step,
                            isStepCompleted: i < step
                        };
                    }), true), [
                        {
                            stepText: 'Payment',
                            isStepActive: false,
                            isStepCompleted: false
                        },
                    ], false) : [
                    {
                        stepText: 'Your Details',
                        isStepActive: true,
                        isStepCompleted: false
                    },
                    {
                        stepText: 'Your Quotes',
                        isStepActive: false,
                        isStepCompleted: false
                    },
                ], nextButtonText: formik.status == 'disabled' ? 'Saving' : 'Next', backButtonText: "Back", isBackDisabled: step === 0 || formik.status == 'disabled', buttonHidden: (unifiedState === null || unifiedState === void 0 ? void 0 : unifiedState.action) === UNIFIED_ACTION.SHOW_ACK_QUESTIONS_TO_FE ||
                    (unifiedState === null || unifiedState === void 0 ? void 0 : unifiedState.action) ===
                        UNIFIED_ACTION.SHOW_COVERAGE_QUESTIONS_TO_FE, isNextDisabled: formik.status == 'disabled', isCloseDisabled: formik.status == 'disabled', handleBack: function () { return onBack(formik.values); }, shouldConfirm: (unifiedState === null || unifiedState === void 0 ? void 0 : unifiedState.action) === UNIFIED_ACTION.SHOW_ACK_QUESTIONS_TO_FE ||
                    (unifiedState === null || unifiedState === void 0 ? void 0 : unifiedState.action) ===
                        UNIFIED_ACTION.SHOW_COVERAGE_QUESTIONS_TO_FE, handleClose: function () {
                    if ((unifiedState === null || unifiedState === void 0 ? void 0 : unifiedState.action) ===
                        UNIFIED_ACTION.SHOW_ACK_QUESTIONS_TO_FE ||
                        (unifiedState === null || unifiedState === void 0 ? void 0 : unifiedState.action) ===
                            UNIFIED_ACTION.SHOW_COVERAGE_QUESTIONS_TO_FE) {
                        setUnifiedState({});
                    }
                    else {
                        toggleModal();
                        setIsEditRequested(false);
                        setSelectedQuote(null);
                        setCurrQuestionGroup(0);
                    }
                } }),
            isModern ? (React.createElement("h2", { className: "text-left text-[32px] font-bold text-[#15161E] mt-6 mb-2 px-6" }, title || getGroupDetailsTitle(groupKey))) : (React.createElement("div", { className: "flex flex-col bg-white z-0 w-full py-4 px-6" },
                React.createElement(PolicyFormProgressBar, { steps: Math.max(totalSteps - skippedGroups, 0), activeStep: Math.min(Math.max(step + 1 - skippedGroups, 1), Math.max(totalSteps - skippedGroups, 1)) }),
                step === 0 && (React.createElement("div", { className: "absolute top-3/4 left-1/2 transform -translate-x-1/2 z-40 block lg:hidden animate-fadeOut" },
                    React.createElement("div", { className: "bg-red-50 border border-red-200 rounded-lg shadow-sm p-4 mx-2 mt-8 w-[90vw] max-w-[680px]" },
                        React.createElement("div", { className: "flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-2 text-center" },
                            React.createElement(FontAwesomeIcon, { icon: faExclamationTriangle, size: "sm", className: "text-red-500" }),
                            React.createElement("p", { className: "text-sm sm:text-base text-red-700 font-medium text-center" }, "For the best experience, please maximize the application window on a laptop or desktop."))))),
                React.createElement("h2", { className: "capitalize text-2xl text-[#1F2751] font-bold mt-3 text-center" }, removeUnderScore(title) ||
                    removeUnderScore(getGroupDetailsTitle(groupKey))),
                subTitle && (React.createElement("h3", { className: "text-xl text-[#1F2751] font-medium mt-1 text-center" }, subTitle)),
                sectionBanner && (React.createElement("div", { className: "sectionBanner" },
                    React.createElement("div", { className: "w-full bg-red-50 border border-red-300 rounded-md px-4 py-3 shadow-sm" },
                        React.createElement("div", { className: "text-red-700 text-sm leading-snug text-center", dangerouslySetInnerHTML: {
                                __html: DOMPurify.sanitize(sectionBanner)
                            } }))))))),
        React.createElement("div", { className: "w-full px-6 pt-14 md:pt-10 overflow-y-auto h-full relative z-0 custom-scrollbar", id: "form-container" },
            formTopText && (React.createElement("h3", { className: "text-primary text-lg pb-8 text-left font-semibold" }, formTopText)),
            (unifiedState === null || unifiedState === void 0 ? void 0 : unifiedState.action) ===
                UNIFIED_ACTION.SHOW_COVERAGE_QUESTIONS_TO_FE ? (React.createElement("h3", { className: "text-black text-lg pb-1 text-left font-semibold" },
                "Quote ID: ",
                unifiedState.quoteId)) : null,
            (unifiedState === null || unifiedState === void 0 ? void 0 : unifiedState.action) === UNIFIED_ACTION.SHOW_ACK_QUESTIONS_TO_FE && (React.createElement("div", { className: "flex flex-col items-start border-b border-[#F4F7FE] mb-2" },
                React.createElement("label", { className: "inline-flex items-center gap-3 py-4 mb-2 rounded-lg cursor-pointer transition-colors" },
                    React.createElement("div", { className: "flex items-center h-5" },
                        React.createElement("input", { type: "checkbox", checked: allChecked, onChange: function (e) { return handleMasterToggle(e.target.checked); }, className: "w-5 h-5 accent-primary bg-white border-gray-300 rounded focus:accent-primary cursor-pointer" })),
                    React.createElement("span", { className: "text-base font-semibold text-gray-900 select-none" }, "Select All Acknowledgements")))),
            React.createElement("div", { className: "gap-x-8 gap-y-6 py-4", id: "form-parent" }, renderRecursively(renderData.struct)))));
};
var Form = function (_a) {
    var _b;
    var productQuestionSet = _a.productQuestionSet, formTopText = _a.formTopText, createDraftQuote = _a.createDraftQuote;
    var _c = useWidgetStore(), setCurrQuestionGroup = _c.setCurrQuestionGroup, currQuestionGroup = _c.currQuestionGroup, initialValues = _c.answers, applicationDataId = _c.applicationDataId;
    var latestQuote = useLatestQuote(applicationDataId);
    var _d = useState(0), skippedGroups = _d[0], setSkippedGroups = _d[1];
    var _e = useState(null), apiValidationErrors = _e[0], setApiValidationErrors = _e[1];
    var questionSetParts = Object.keys(productQuestionSet).sort(function (a, b) {
        var seqA = productQuestionSet[a].seq;
        var seqB = productQuestionSet[b].seq;
        var hasA = seqA !== undefined && seqA !== null;
        var hasB = seqB !== undefined && seqB !== null;
        if (hasA && hasB)
            return seqA - seqB;
        if (hasA)
            return -1;
        if (hasB)
            return 1;
        return 0;
    });
    useEffect(function () {
        if (questionSetParts.length === 0) {
            if (currQuestionGroup !== 0) {
                setCurrQuestionGroup(0);
            }
            return;
        }
        if (currQuestionGroup < 0 || currQuestionGroup >= questionSetParts.length) {
            console.warn('[Form] Invalid currQuestionGroup detected. Resetting to first question group.', {
                currQuestionGroup: currQuestionGroup,
                questionSetParts: questionSetParts,
                questionSetLength: questionSetParts.length
            });
            setCurrQuestionGroup(0);
        }
    }, [questionSetParts.length, currQuestionGroup, setCurrQuestionGroup]);
    var currentGroupKey = questionSetParts[currQuestionGroup];
    var _f = useMemo(function () {
        if (!currentGroupKey) {
            return {
                questions: [],
                title: '',
                subTitle: '',
                sectionBanner: ''
            };
        }
        return (productQuestionSet[currentGroupKey] || {
            questions: [],
            title: '',
            subTitle: '',
            sectionBanner: ''
        });
    }, [productQuestionSet, currentGroupKey]), questions = _f.questions, title = _f.title, subTitle = _f.subTitle, sectionBanner = _f.sectionBanner;
    var groupTable_AnswerMapper = function (allGroupAnswers) {
        var _a;
        if (!currentGroupKey) {
            return allGroupAnswers;
        }
        var currentGroupAnswers = structuredClone((_a = allGroupAnswers[currentGroupKey]) !== null && _a !== void 0 ? _a : {});
        questions.forEach(function (ques) {
            if (ques.inputType === 'group' &&
                ques.renderAs === 'multi_table' &&
                ques.targetQuestionKey) {
                var multiSelectAnswers = currentGroupAnswers[ques.targetQuestionKey] || [];
                if (multiSelectAnswers && Array.isArray(multiSelectAnswers)) {
                    for (var i = -1; i < multiSelectAnswers.length; i++) {
                        var value = multiSelectAnswers[i + 1];
                        if (i === -1 || i + 1 < multiSelectAnswers.length) {
                            currentGroupAnswers["".concat(ques.targetQuestionKey, "__").concat(i + 1)] =
                                value || '';
                        }
                    }
                    // delete currentGroupAnswers[ques.targetQuestionKey];
                }
            }
        });
        allGroupAnswers[currentGroupKey] = currentGroupAnswers;
        return allGroupAnswers;
    };
    var _g = useState(flattenNestedGroupAnswers(initialValues)), answers = _g[0], setAnswers = _g[1];
    useEffect(function () {
        if (latestQuote) {
            if (latestQuote.status == 'pending' || latestQuote.status == 'draft') {
                if (latestQuote.partnerData &&
                    latestQuote.partnerIdentifier === 'brizaUnifiedHiscox' &&
                    latestQuote.partnerData.error !== null &&
                    latestQuote.partnerData.error !== undefined) {
                    console.log({ error: latestQuote.partnerData.error });
                    if (typeof latestQuote.partnerData.error === 'object' &&
                        latestQuote.partnerData.error.mapped &&
                        Object.keys(latestQuote.partnerData.error.mapped).length) {
                        var questionErrors = latestQuote.partnerData.error.mapped;
                        console.log({ questionErrors: questionErrors });
                        var questionErrorKeys = Object.keys(questionErrors);
                        var firstErrorSetIndex = Infinity;
                        for (var i = 0; i < questionSetParts.length; i++) {
                            var setKey = questionSetParts[i];
                            var currAnsSet = initialValues[setKey];
                            for (var j = 0; j < questionErrorKeys.length; j++) {
                                var errorKey = questionErrorKeys[j];
                                var answer = searchValueRecursively(currAnsSet, errorKey);
                                if (answer !== undefined) {
                                    if (firstErrorSetIndex > i) {
                                        firstErrorSetIndex = i;
                                    }
                                }
                            }
                        }
                        setApiValidationErrors(questionErrors);
                        if (firstErrorSetIndex > -1 &&
                            firstErrorSetIndex < questionSetParts.length) {
                            setCurrQuestionGroup(firstErrorSetIndex);
                        }
                    }
                    else {
                        // Clear any previous validation errors if the new quote doesn't have them
                        setApiValidationErrors(null);
                    }
                }
                else {
                    // Clear any previous validation errors if the new quote doesn't have them
                    setApiValidationErrors(null);
                }
            }
        }
    }, [
        JSON.stringify(((_b = latestQuote === null || latestQuote === void 0 ? void 0 : latestQuote.partnerData) === null || _b === void 0 ? void 0 : _b.error) || {}),
        latestQuote === null || latestQuote === void 0 ? void 0 : latestQuote.status,
    ]);
    var updateSectionAnswers = function (newSectionAnswers) {
        var _a;
        if (!currentGroupKey) {
            console.warn('[Form] Cannot update section answers because currentGroupKey is undefined.', {
                currQuestionGroup: currQuestionGroup,
                questionSetParts: questionSetParts
            });
            return answers;
        }
        var oldSectionAnswers = answers[currentGroupKey] || {};
        var mappedAnswer = updateAnswerTableMapper(newSectionAnswers, oldSectionAnswers);
        var filteredAnswers = pruneStaleValues(mappedAnswer, answers, questions, currentGroupKey);
        var latestAnswers = __assign(__assign({}, answers), (_a = {}, _a[currentGroupKey] = filteredAnswers, _a));
        setAnswers(flattenNestedGroupAnswers(latestAnswers));
        return latestAnswers;
    };
    var updateAnswerTableMapper = function (newSectionAnswers, oldSectionAnswers) {
        var tempAnswer = __assign({}, newSectionAnswers);
        questions.forEach(function (ques) {
            if (ques.inputType === 'group' &&
                ques.renderAs === 'multi_table' &&
                ques.targetQuestionKey) {
                var regex_1 = new RegExp("^".concat(ques.targetQuestionKey, "__([0-9]+)$"));
                // Only process keys that are in newSectionAnswers
                var groupedList_1 = Object.keys(tempAnswer)
                    .filter(function (key) { return regex_1.test(key); })
                    .map(function (key) {
                    var value = tempAnswer[key];
                    delete tempAnswer[key];
                    return value;
                });
                if (groupedList_1.length) {
                    tempAnswer[ques.targetQuestionKey] = groupedList_1;
                    // Clean up related keys that should be removed
                    Object.keys(tempAnswer).forEach(function (key) {
                        if (key.startsWith("".concat(ques.questionKey, "_")) &&
                            !groupedList_1.includes(key.replace("".concat(ques.questionKey, "_"), ''))) {
                            delete tempAnswer[key];
                        }
                    });
                }
                else {
                    // If no grouped items found in newSectionAnswers,
                    // remove the target key if it exists in old answers
                    if (oldSectionAnswers[ques.targetQuestionKey]) {
                        delete tempAnswer[ques.targetQuestionKey];
                    }
                }
            }
        });
        return tempAnswer;
    };
    var onGroupSubmit = function (newSectionAnswers, setSubmitting) { return __awaiter(void 0, void 0, void 0, function () {
        var latestAnswers, isLast, el;
        return __generator(this, function (_a) {
            if (!currentGroupKey) {
                console.warn('[Form] Prevented submit because currentGroupKey is undefined.', {
                    currQuestionGroup: currQuestionGroup,
                    questionSetParts: questionSetParts
                });
                setSubmitting('enable');
                return [2 /*return*/];
            }
            setSubmitting('disabled');
            latestAnswers = updateSectionAnswers(newSectionAnswers);
            isLast = currQuestionGroup === questionSetParts.length - 1;
            createDraftQuote(latestAnswers, isLast && currentGroupKey === 'your_business' ? 0 : currQuestionGroup, isLast)
                .then(function () {
                if (!isLast) {
                    var nextGroup = currQuestionGroup + 1;
                    if (nextGroup < questionSetParts.length) {
                        setCurrQuestionGroup(nextGroup);
                    }
                }
            })["catch"](function (err) { return console.log(err); })["finally"](function () { return setSubmitting('enable'); });
            el = document.getElementById('containerId');
            if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
            return [2 /*return*/];
        });
    }); };
    var onBack = function (newSectionAnswers) {
        if (!currentGroupKey || currQuestionGroup <= 0) {
            return;
        }
        updateSectionAnswers(newSectionAnswers);
        setCurrQuestionGroup(currQuestionGroup - 1);
    };
    if (questionSetParts.length === 0 || !currentGroupKey) {
        return null;
    }
    return (React.createElement("div", { className: "flex justify-center w-full h-full text-textColor" }, questions && (React.createElement(FormSection, { key: currentGroupKey, answers: groupTable_AnswerMapper(answers), title: title, subTitle: subTitle, sectionBanner: sectionBanner, questions: questions, step: currQuestionGroup, totalSteps: questionSetParts.length, groups: questionSetParts, groupKey: currentGroupKey, skippedGroups: skippedGroups, onSubmit: onGroupSubmit, formTopText: formTopText, onBack: onBack, apiValidationErrors: apiValidationErrors }))));
};
export default Form;
